<template>
  <div>

    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <div class="row">
            <div class="col-sm-12" id="app">
              <div>
                <div class v-show="!carregando">
                  <div class="table-responsive" data-auto>
                    <div id="mensagem"></div>
                    <div id="errors" v-if="errors.length > 0">
                      <div class="style-msg2 errormsg">
                        <div class="msgtitle">Corrigir o(s) seguinte(s) erro(s):</div>
                        <div class="sb-msg">
                          <ul>
                            <li :key="index" v-for="(error,index) in errors">{{error}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <vs-table :striped="true" search max-items="15" pagination :data="content">
                    <template slot="header" class="header-vstable">
                      <div class="area-header">
                        <h3>Contratos</h3>
                      </div>
                    </template>
                    <template slot="thead">
                      <vs-th style="width:45px;" class="text-center"> </vs-th>
                      <vs-th style="text-align:center;"  class="text-center" :style="'width:'+iconArea+'px'">Ações</vs-th>
                      <vs-th sort-key="nomeEmpresa">Serviço <small> /  Contrato</small></vs-th>
                      <vs-th class="text-center" >Pago</vs-th>
                      <vs-th >Preço</vs-th>
                      <vs-th >Data pagamento</vs-th>
                      <vs-th >Data contratação</vs-th>
                      <vs-th sort-key="status">Status</vs-th>
                      <vs-th sort-key="clienteID" style="width:45px;">ID</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="indextr"  class="text-center" >{{indextr + 1}}</vs-td>
                        <vs-td  class="text-center acoes">
                          <a
                            class="icone-editar"
                            data-editar
                            @click="fnEdita('/paineldegerenciamento/contrato/etapa1/'+data[indextr].codigoContratacao)"
                          >
                            <i class="i-circled i-small i-light icon-eye-open"></i>
                          </a>
                        </vs-td>
                       <vs-td :data="data[indextr].cnpj">{{data[indextr].servicos.titulo}}
                         <br>
                         <small>{{data[indextr].codigoContratacao}}</small>
                       </vs-td>
                       <vs-td :data="data[indextr].pago" class="text-icon text-center">
                          <i  @click="fnAtiva(data[indextr].contratacaoId,data[indextr].servicos.titulo + ' - ' + data[indextr].codigoContratacao,data[indextr].pago)"
                            class="i-rounded i-small icon-check i-small-xs"
                            :style="data[indextr].pago ? 'background-color:#2ecc71': 'background-color:#D3D3D3'"
                          ></i>
                       </vs-td>
                       <vs-td>R$ {{formatPreco(data[indextr].preco)}}</vs-td>
                       <vs-td :data="data[indextr].tsPagamento">{{formatData(data[indextr].tsPagamento)}}</vs-td>
                       <vs-td>{{formatData(data[indextr].tsContratacao)}}</vs-td>
                       <vs-td :data="data[indextr].status">{{data[indextr].status}}</vs-td>
                      <vs-td :data="data[indextr].clienteID">{{data[indextr].contratacaoId}}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>

<script>
import { getData, formatPrice } from "../../global/utils";

export default {
  
  data: function () {
    return {
      stripe: true,
      colorAlert: "primary",
      titleAlert: '',
      activeAlert: false,
      content: [],
      iconArea: 45 * 1,
      errors: [],
      erro: "",
      urlApi: "contratacao/lista/admin/",
      carregando: true,
      pagoId: "",
      pagoAtivo: null,
      pagoTitulo: "",
    };
  },
  mounted() {
    this.fnCarregaItems();
  },
  methods: {
    async fnCarregaItems() {
      let data = await getData(this.urlApi+this.$route.params.id);
      this.content = data[0].content;
      this.carregando = false;
      this.$vs.loading.close();
    },
    fnAdd() {
      this.$router.push({path: "/paineldegerenciamento/servicos/novo"})
    },
    formatData(value) {
      if (value == '' || value == null){
        return "---";

      }else{
        return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");

      }
    },
    formatPreco(value) {
      return formatPrice(value);
    },
    fnAtiva(valueId, valueTitle, valueAtivo) {
      if (!valueAtivo){
        this.pagoId = valueId;
        this.pagoTitulo = valueTitle;
        this.pagoAtivo = valueAtivo
        this.$vs.dialog({
          color: this.colorAlert,
          acceptText: 'Continuar',
          title: "Deseja confirmar o recebimento do serviço " + valueTitle + "? " ,
          text: "Um e-mail será encaminhado para o cliente com a confirmação de recebimento.",
          accept: this.fn_pago,
        });
      }else{
        this.$vs.dialog({
          color: this.colorAlert,
          acceptText: 'Ok',
          title: "A confirmação de pagamento já foi realizada!" ,
        });

      }
    },
    async fn_pago() {
      let dados={
        Data: this.$moment().format("YYYY-MM-DD HH:MM"),
        valor: true,
        Tipo: "Pagamento",
        contratacaoId: this.pagoId
      }
      await this.$http.put("/contratacao/status/admin/"+this.pagoId,dados)
      this.fnCarregaItems();
      this.pagoAtivo = null
    },
    fnEdita(valueUrl){
        this.$router.push({path: valueUrl})
    },
    fnLength(val){
      if (val == null){return 0}
      return  val.length
    }
  },

};
</script>

<style lang="less" scoped>
#page-menu-wrap {
  position: relative !important;
}
.vs-table-text {
  text-align: center;
}

.text-icon {
  span {
    display: block !important;
    text-align: center !important;
  }
  .i-small-xs {
    font-size: 10px !important;
    margin: 0 !important;
    height: 16px !important;
    width: 16px !important;
    line-height: 16px !important;
    float: none !important;
  }
}
.header-table {
  padding: 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}
.text-icon {
  span {
    display: block !important;
    text-align: center !important;
  }
  .i-small-xs {
    font-size: 10px !important;
    margin: 0 !important;
    height: 16px !important;
    width: 16px !important;
    line-height: 16px !important;
    float: none !important;
  }
}

</style>